import {
  enumCurrencyCode as CurrencyCode,
  enumCurrencyCode,
} from '@rematter/frontend-lib-api-client';
import { LucideIcon, Flag } from 'lucide-react';

export type Currency = {
  code: keyof typeof enumCurrencyCode | 'BTC' | 'ETH' | 'LTC';
  symbol: string;
  name: string;
  icon?: LucideIcon;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

export type CurrencySummary = Pick<Currency, 'code' | 'symbol' | 'name'>;

export const allCurrencies: Currency[] = [
  {
    code: enumCurrencyCode.USD,
    symbol: '$',
    name: 'United States Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: enumCurrencyCode.EUR,
    symbol: '€',
    name: 'Euro',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: enumCurrencyCode.GBP,
    symbol: '£',
    name: 'British Pound Sterling',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: enumCurrencyCode.JPY,
    symbol: '¥',
    name: 'Japanese Yen',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: enumCurrencyCode.AUD,
    symbol: 'A$',
    name: 'Australian Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: enumCurrencyCode.CAD,
    symbol: 'C$',
    name: 'Canadian Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: enumCurrencyCode.CHF,
    symbol: 'Fr',
    name: 'Swiss Franc',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: enumCurrencyCode.CNY,
    symbol: '¥',
    name: 'Chinese Yuan',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: enumCurrencyCode.INR,
    symbol: '₹',
    name: 'Indian Rupee',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BRL',
    symbol: 'R$',
    name: 'Brazilian Real',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'RUB',
    symbol: '₽',
    name: 'Russian Ruble',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SGD',
    symbol: 'S$',
    name: 'Singapore Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'NZD',
    symbol: 'NZ$',
    name: 'New Zealand Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'AED',
    symbol: 'د.إ',
    name: 'United Arab Emirates Dirham',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'AFN',
    symbol: '؋',
    name: 'Afghan Afghani',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'ALL',
    symbol: 'L',
    name: 'Albanian Lek',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'AMD',
    symbol: '֏',
    name: 'Armenian Dram',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'ANG',
    symbol: 'ƒ',
    name: 'Netherlands Antillean Guilder',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'AOA',
    symbol: 'Kz',
    name: 'Angolan Kwanza',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'ARS',
    symbol: '$',
    name: 'Argentine Peso',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'AWG',
    symbol: 'ƒ',
    name: 'Aruban Florin',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'AZN',
    symbol: '₼',
    name: 'Azerbaijani Manat',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BAM',
    symbol: 'KM',
    name: 'Bosnia-Herzegovina Convertible Mark',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BBD',
    symbol: '$',
    name: 'Barbadian Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BDT',
    symbol: '৳',
    name: 'Bangladeshi Taka',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BGN',
    symbol: 'лв',
    name: 'Bulgarian Lev',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BHD',
    symbol: '.د.ب',
    name: 'Bahraini Dinar',
    icon: Flag,
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  },
  {
    code: 'BIF',
    symbol: 'FBu',
    name: 'Burundian Franc',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'BMD',
    symbol: '$',
    name: 'Bermudan Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BND',
    symbol: 'B$',
    name: 'Brunei Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BOB',
    symbol: 'Bs.',
    name: 'Bolivian Boliviano',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BSD',
    symbol: 'B$',
    name: 'Bahamian Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BTN',
    symbol: 'Nu.',
    name: 'Bhutanese Ngultrum',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BWP',
    symbol: 'P',
    name: 'Botswanan Pula',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BYN',
    symbol: 'Br',
    name: 'Belarusian Ruble',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'BZD',
    symbol: 'BZ$',
    name: 'Belize Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'CDF',
    symbol: 'FC',
    name: 'Congolese Franc',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'CLP',
    symbol: '$',
    name: 'Chilean Peso',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'COP',
    symbol: '$',
    name: 'Colombian Peso',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'CRC',
    symbol: '₡',
    name: 'Costa Rican Colón',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'CUC',
    symbol: '$',
    name: 'Cuban Convertible Peso',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'CUP',
    symbol: '₱',
    name: 'Cuban Peso',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'CVE',
    symbol: '$',
    name: 'Cape Verdean Escudo',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'CZK',
    symbol: 'Kč',
    name: 'Czech Koruna',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'DJF',
    symbol: 'Fdj',
    name: 'Djiboutian Franc',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'DKK',
    symbol: 'kr',
    name: 'Danish Krone',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'DOP',
    symbol: 'RD$',
    name: 'Dominican Peso',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'DZD',
    symbol: 'د.ج',
    name: 'Algerian Dinar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'EGP',
    symbol: 'E£',
    name: 'Egyptian Pound',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'ERN',
    symbol: 'Nfk',
    name: 'Eritrean Nakfa',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'ETB',
    symbol: 'Br',
    name: 'Ethiopian Birr',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'FJD',
    symbol: 'FJ$',
    name: 'Fijian Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'FKP',
    symbol: '£',
    name: 'Falkland Islands Pound',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'GEL',
    symbol: '₾',
    name: 'Georgian Lari',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'GHS',
    symbol: '₵',
    name: 'Ghanaian Cedi',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'GIP',
    symbol: '£',
    name: 'Gibraltar Pound',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'GMD',
    symbol: 'D',
    name: 'Gambian Dalasi',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'GNF',
    symbol: 'FG',
    name: 'Guinean Franc',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'GTQ',
    symbol: 'Q',
    name: 'Guatemalan Quetzal',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'GYD',
    symbol: '$',
    name: 'Guyanaese Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'HKD',
    symbol: 'HK$',
    name: 'Hong Kong Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'HNL',
    symbol: 'L',
    name: 'Honduran Lempira',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'HRK',
    symbol: 'kn',
    name: 'Croatian Kuna',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'HTG',
    symbol: 'G',
    name: 'Haitian Gourde',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'HUF',
    symbol: 'Ft',
    name: 'Hungarian Forint',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'IDR',
    symbol: 'Rp',
    name: 'Indonesian Rupiah',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'ILS',
    symbol: '₪',
    name: 'Israeli New Shekel',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'IQD',
    symbol: 'ع.د',
    name: 'Iraqi Dinar',
    icon: Flag,
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  },
  {
    code: 'IRR',
    symbol: '﷼',
    name: 'Iranian Rial',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'ISK',
    symbol: 'kr',
    name: 'Icelandic Króna',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'JMD',
    symbol: 'J$',
    name: 'Jamaican Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'JOD',
    symbol: 'د.ا',
    name: 'Jordanian Dinar',
    icon: Flag,
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  },
  {
    code: 'KES',
    symbol: 'KSh',
    name: 'Kenyan Shilling',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'KGS',
    symbol: 'с',
    name: 'Kyrgystani Som',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'KHR',
    symbol: '៛',
    name: 'Cambodian Riel',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'KMF',
    symbol: 'CF',
    name: 'Comorian Franc',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'KPW',
    symbol: '₩',
    name: 'North Korean Won',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'KRW',
    symbol: '₩',
    name: 'South Korean Won',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'KWD',
    symbol: 'د.ك',
    name: 'Kuwaiti Dinar',
    icon: Flag,
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  },
  {
    code: 'KYD',
    symbol: '$',
    name: 'Cayman Islands Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'KZT',
    symbol: '₸',
    name: 'Kazakhstani Tenge',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'LAK',
    symbol: '₭',
    name: 'Laotian Kip',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'LBP',
    symbol: 'ل.ل',
    name: 'Lebanese Pound',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'LKR',
    symbol: 'Rs',
    name: 'Sri Lankan Rupee',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'LRD',
    symbol: '$',
    name: 'Liberian Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'LSL',
    symbol: 'L',
    name: 'Lesotho Loti',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'LYD',
    symbol: 'ل.د',
    name: 'Libyan Dinar',
    icon: Flag,
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  },
  {
    code: 'MAD',
    symbol: 'د.م.',
    name: 'Moroccan Dirham',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MDL',
    symbol: 'L',
    name: 'Moldovan Leu',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MGA',
    symbol: 'Ar',
    name: 'Malagasy Ariary',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MKD',
    symbol: 'ден',
    name: 'Macedonian Denar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MMK',
    symbol: 'K',
    name: 'Myanmar Kyat',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MNT',
    symbol: '₮',
    name: 'Mongolian Tugrik',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MOP',
    symbol: 'MOP$',
    name: 'Macanese Pataca',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MRU',
    symbol: 'UM',
    name: 'Mauritanian Ouguiya',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MUR',
    symbol: '₨',
    name: 'Mauritian Rupee',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MVR',
    symbol: 'Rf',
    name: 'Maldivian Rufiyaa',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MWK',
    symbol: 'MK',
    name: 'Malawian Kwacha',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MXN',
    symbol: '$',
    name: 'Mexican Peso',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MYR',
    symbol: 'RM',
    name: 'Malaysian Ringgit',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'MZN',
    symbol: 'MT',
    name: 'Mozambican Metical',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'NAD',
    symbol: '$',
    name: 'Namibian Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'NGN',
    symbol: '₦',
    name: 'Nigerian Naira',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'NIO',
    symbol: 'C$',
    name: 'Nicaraguan Córdoba',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'NOK',
    symbol: 'kr',
    name: 'Norwegian Krone',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'NPR',
    symbol: '₨',
    name: 'Nepalese Rupee',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'OMR',
    symbol: 'ر.ع.',
    name: 'Omani Rial',
    icon: Flag,
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  },
  {
    code: 'PAB',
    symbol: 'B/.',
    name: 'Panamanian Balboa',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'PEN',
    symbol: 'S/',
    name: 'Peruvian Nuevo Sol',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'PGK',
    symbol: 'K',
    name: 'Papua New Guinean Kina',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'PHP',
    symbol: '₱',
    name: 'Philippine Peso',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'PKR',
    symbol: '₨',
    name: 'Pakistani Rupee',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'PLN',
    symbol: 'zł',
    name: 'Polish Złoty',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'PYG',
    symbol: '₲',
    name: 'Paraguayan Guarani',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'QAR',
    symbol: 'ر.ق',
    name: 'Qatari Rial',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'RON',
    symbol: 'lei',
    name: 'Romanian Leu',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'RSD',
    symbol: 'дин.',
    name: 'Serbian Dinar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'RWF',
    symbol: 'FRw',
    name: 'Rwandan Franc',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'SAR',
    symbol: 'ر.س',
    name: 'Saudi Riyal',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SBD',
    symbol: '$',
    name: 'Solomon Islands Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SCR',
    symbol: '₨',
    name: 'Seychellois Rupee',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SDG',
    symbol: 'ج.س.',
    name: 'Sudanese Pound',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SEK',
    symbol: 'kr',
    name: 'Swedish Krona',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SHP',
    symbol: '£',
    name: 'Saint Helena Pound',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SLL',
    symbol: 'Le',
    name: 'Sierra Leonean Leone',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SOS',
    symbol: 'S',
    name: 'Somali Shilling',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SRD',
    symbol: '$',
    name: 'Surinamese Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SSP',
    symbol: '£',
    name: 'South Sudanese Pound',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'STN',
    symbol: 'Db',
    name: 'São Tomé and Príncipe Dobra',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SVC',
    symbol: '₡',
    name: 'Salvadoran Colón',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SYP',
    symbol: '£',
    name: 'Syrian Pound',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'SZL',
    symbol: 'L',
    name: 'Swazi Lilangeni',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'THB',
    symbol: '฿',
    name: 'Thai Baht',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'TJS',
    symbol: 'ЅМ',
    name: 'Tajikistani Somoni',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'TMT',
    symbol: 'T',
    name: 'Turkmenistani Manat',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'TND',
    symbol: 'د.ت',
    name: 'Tunisian Dinar',
    icon: Flag,
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  },
  {
    code: 'TOP',
    symbol: 'T$',
    name: 'Tongan Paʻanga',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'TRY',
    symbol: '₺',
    name: 'Turkish Lira',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'TTD',
    symbol: 'TT$',
    name: 'Trinidad and Tobago Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'TWD',
    symbol: 'NT$',
    name: 'New Taiwan Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'TZS',
    symbol: 'TSh',
    name: 'Tanzanian Shilling',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'UAH',
    symbol: '₴',
    name: 'Ukrainian Hryvnia',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'UGX',
    symbol: 'USh',
    name: 'Ugandan Shilling',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'UYU',
    symbol: '$U',
    name: 'Uruguayan Peso',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'UZS',
    symbol: 'сўм',
    name: 'Uzbekistan Som',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'VES',
    symbol: 'Bs.S',
    name: 'Venezuelan Bolívar Soberano',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'VND',
    symbol: '₫',
    name: 'Vietnamese Dong',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'VUV',
    symbol: 'VT',
    name: 'Vanuatu Vatu',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'WST',
    symbol: 'WS$',
    name: 'Samoan Tala',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'XAF',
    symbol: 'FCFA',
    name: 'CFA Franc BEAC',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'XCD',
    symbol: 'EC$',
    name: 'East Caribbean Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'XOF',
    symbol: 'CFA',
    name: 'CFA Franc BCEAO',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'XPF',
    symbol: '₣',
    name: 'CFP Franc',
    icon: Flag,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  {
    code: 'YER',
    symbol: '﷼',
    name: 'Yemeni Rial',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'ZAR',
    symbol: 'R',
    name: 'South African Rand',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'ZMW',
    symbol: 'ZK',
    name: 'Zambian Kwacha',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  {
    code: 'ZWL',
    symbol: 'Z$',
    name: 'Zimbabwean Dollar',
    icon: Flag,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
];

export const getCurrencyByCode = (
  code: keyof typeof CurrencyCode,
): Currency | undefined =>
  allCurrencies.find((currency) => currency.code === code);

export const getFormatOptionsByCurrency = (
  code: keyof typeof CurrencyCode,
): Intl.NumberFormatOptions => {
  const currency = getCurrencyByCode(code);
  return {
    style: 'currency',
    currency: code,
    minimumFractionDigits: currency?.minimumFractionDigits ?? 2,
    maximumFractionDigits: currency?.maximumFractionDigits ?? 2,
  };
};

export const formatMoney = (
  amount: number | null | undefined,
  currencyCode: string | null | undefined,
  locale?: string,
): string => {
  if (amount == null || !currencyCode) return '-';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
    }).format(amount);
  } catch {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }
};

export const formatPercent = (
  value: number | null | undefined,
  locale?: string,
): string => {
  if (value == null) return '-';
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value / 100);
};
